import clsx from 'clsx';
import React from 'react';

export default function GoogleSheetIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 74 100"
      className={clsx('text-current', className)}
    >
      <mask
        id="a"
        width="71"
        height="98"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
        />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#0F9D58"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L56.436 16.884 45.398 1.43Z"
        />
      </g>
      <mask
        id="b"
        width="71"
        height="98"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#F1F1F1"
          d="M18.905 48.896v32.012H54.23V48.896H18.905ZM34.36 76.493H23.321v-5.52h11.038v5.52Zm0-8.831H23.321v-5.52h11.038v5.52Zm0-8.831H23.321v-5.52h11.038v5.52Zm15.454 17.662H38.775v-5.52h11.038v5.52Zm0-8.831H38.775v-5.52h11.038v5.52Zm0-8.831H38.775v-5.52h11.038v5.52Z"
        />
      </g>
      <mask
        id="c"
        width="71"
        height="98"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
        />
      </mask>
      <g mask="url(#c)">
        <path
          fill="url(#d)"
          d="m47.335 25.986 24.556 24.55V27.922l-24.556-1.937Z"
        />
      </g>
      <mask
        id="e"
        width="71"
        height="98"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
        />
      </mask>
      <g mask="url(#e)">
        <path
          fill="#87CEAC"
          d="M45.398 1.43V21.3a6.621 6.621 0 0 0 6.623 6.623h19.87L45.398 1.43Z"
        />
      </g>
      <mask
        id="f"
        width="71"
        height="98"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
        />
      </mask>
      <g mask="url(#f)">
        <path
          fill="#fff"
          fillOpacity=".2"
          d="M7.867 1.43c-3.643 0-6.623 2.98-6.623 6.623v.552c0-3.642 2.98-6.623 6.623-6.623h37.531V1.43H7.867Z"
        />
      </g>
      <mask
        id="g"
        width="71"
        height="98"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
        />
      </mask>
      <g mask="url(#g)">
        <path
          fill="#263238"
          fillOpacity=".2"
          d="M65.267 98.018h-57.4c-3.643 0-6.623-2.98-6.623-6.623v.552c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623v-.552c0 3.642-2.98 6.623-6.624 6.623Z"
        />
      </g>
      <mask
        id="h"
        width="71"
        height="98"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
        />
      </mask>
      <g mask="url(#h)">
        <path
          fill="#263238"
          fillOpacity=".1"
          d="M52.021 27.923a6.621 6.621 0 0 1-6.623-6.623v.552a6.621 6.621 0 0 0 6.623 6.623h19.87v-.552H52.02Z"
        />
      </g>
      <path
        fill="url(#i)"
        d="M45.398 1.43H7.867c-3.643 0-6.623 2.98-6.623 6.623v83.894c0 3.642 2.98 6.623 6.623 6.623h57.4c3.643 0 6.624-2.98 6.624-6.623V27.922L45.398 1.43Z"
      />
      <defs>
        <radialGradient
          id="i"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(3.482 3.361) scale(113.917)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity=".1" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="d"
          x1="59.614"
          x2="59.614"
          y1="28.093"
          y2="50.539"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#263238" stopOpacity=".2" />
          <stop offset="1" stopColor="#263238" stopOpacity=".02" />
        </linearGradient>
      </defs>
    </svg>
  );
}
